import { createContext, useCallback, useContext } from 'react';
import * as React from 'react';

import { useLocalStorage } from 'support/react/hooks';

export interface FavoritesContextType {
  items: string[];
  addItem(itemId: string): void;
  removeItem(itemId: string): void;
}

export const FavoritesContext = createContext<FavoritesContextType>({
  items: [],
  addItem: () => {},
  removeItem: () => {},
});

export interface FavoritesContextProviderProps {
  children: React.ReactNode;
}

export const FavoritesContextProvider = ({ children }: FavoritesContextProviderProps) => {
  const [items, setItems] = useLocalStorage<string[]>('favorites', { initialValue: [] });

  const addItem = useCallback<FavoritesContextType['addItem']>(
    itemId => {
      const newItems = [...items, itemId];

      setItems(newItems);
    },
    [items, setItems],
  );

  const removeItem = useCallback<FavoritesContextType['removeItem']>(
    itemId => {
      const newItems = items.filter(id => id !== itemId);

      setItems(newItems);
    },
    [items, setItems],
  );

  return <FavoritesContext.Provider value={{ items, addItem, removeItem }}>{children}</FavoritesContext.Provider>;
};

export function useFavoritesContext(): FavoritesContextType {
  return useContext(FavoritesContext);
}
